import { getOrganizationKey } from './organizationUtils';

export const _setNewOrganizationForm = (state, action) => {
  state.newOrganizationForm = action.payload;
};

export const _setOrgId = (state, action) => {
  state.orgId = action.payload;
};

export const _setOrgKey = (state, action) => {
  state.orgKey = action.payload;
};

export const _setOrganizationName = (state, action) => {
  state.organizationName = action.payload;
};

export const _setAlternateName = (state, action) => {
  state.alternateName = action.payload;
  state.orgKey = getOrganizationKey(state.alternateName);
};

export const _setAccountingContactId = (state, action) => {
  state.accountingContactId = action.payload;
};

export const _setFacilityCoordinatorContactId = (state, action) => {
  state.facilityCoordinatorContactId = action.payload;
};

export const _setCity = (state, action) => {
  state.orgCity = action.payload;
};

export const _setParentOrganizationId = (state, action) => {
  state.parentOrganizationId = action.payload;
};

export const _setAdministrativeContactId = (state, action) => {
  state.administrativeContactId = action.payload;
};

export const _setInvoiceVerificationContactId = (state, action) => {
  state.invoiceVerificationContactId = action.payload;
};

export const _setWCare = (state, action) => {
  state.wCare = action.payload;
};

export const _setParole = (state, action) => {
  state.parole = action.payload;
};

export const _setPrison = (state, action) => {
  state.prison = action.payload;
};

export const _setOther = (state, action) => {
  state.other = action.payload;
};

export const _setCbp = (state, action) => {
  state.cbp = action.payload;
};

export const _setSap = (state, action) => {
  state.sap = action.payload;
};

export const _setStop = (state, action) => {
  state.stop = action.payload;
};

export const _setVendor = (state, action) => {
  state.vendor = action.payload;
};

export const _setInactive = (state, action) => {
  state.inactive = action.payload;
};

export const _setOrgDateCreate = (state, action) => {
  state.orgDateCreate = action.payload;
};

export const _setOrgDateEdit = (state, action) => {
  state.orgDateEdit = action.payload;
};

export const _setOrgCreatedById = (state, action) => {
  state.orgCreatedById = action.payload;
};

export const _setOrgEditedById = (state, action) => {
  state.orgEditedById = action.payload;
};
